import React from 'react';
import { ApolloQueryResult } from '@apollo/client';
import {
  ReservForQuery_db_LRAttestrattReserv_All,
  ReservForQuery,
  ReservForQueryVariables,
  ReservForQuery_reservForKodbehorigheter,
} from '../../../ObjektVyer/Attestant/Components/ReservFor/Queries/_QueryTypes/ReservForQuery';
import {
  LRSysOptionsQuery_db_SYSMoms_All,
  LRSysOptionsQuery_db_SYSOptions_All,
  LRSysOptionsQuery_db_SYSPrisbasbelopp_All,
} from '../../../ObjektVyer/FakturaDel/Queries/LRSysOptionQuery/_QueryTypes/LRSysOptionsQuery';

interface IFakturaattestWrapperContext {
  loading: boolean;
  openReservDialog: boolean;
  refetch: (
    variables?: Partial<ReservForQueryVariables> | undefined
  ) => Promise<ApolloQueryResult<ReservForQuery>>;
  reservForData: ReservForQuery_db_LRAttestrattReserv_All[] | null | undefined;
  reservForKodbehorigheter:
    | (ReservForQuery_reservForKodbehorigheter | null)[]
    | null
    | undefined;
  setOpenReservDialog: (value: boolean) => void;
  sysOptions: LRSysOptionsQuery_db_SYSOptions_All[] | null | undefined;
  sysMoms: LRSysOptionsQuery_db_SYSMoms_All[] | null | undefined;
  sysPrisbasbelopp:
    | LRSysOptionsQuery_db_SYSPrisbasbelopp_All[]
    | null
    | undefined;
}

export const FakturaattestWrapperContext =
  React.createContext<IFakturaattestWrapperContext>({
    loading: false,
    openReservDialog: false,
    refetch: () => {
      return new Promise<ApolloQueryResult<ReservForQuery>>(() => {});
    },
    reservForData: null,
    reservForKodbehorigheter: null,
    setOpenReservDialog: () => {},
    sysOptions: [],
    sysMoms: [],
    sysPrisbasbelopp: [],
  });
